import 'bootstrap/dist/css/bootstrap.min.css';
import { LinkContainer } from 'react-router-bootstrap';

function MatintaPageHeader() {
  return (
    <header data-bs-theme="dark">
      <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div className="container-fluid">
          <LinkContainer to="/">
            <a className="navbar-brand" href="#">Matinta</a>
          </LinkContainer>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav me-auto mb-2 mb-md-0">
              <li className="nav-item">
                <LinkContainer to="/">
                  <a className="nav-link active" aria-current="page">Registrar</a>
                </LinkContainer>
              </li>
              <li className="nav-item">
                <LinkContainer to="/user/login">
                  <a className="nav-link active" aria-current="page">Entrar</a>
                </LinkContainer>
              </li>
              <li className="nav-item">
                <LinkContainer to="/tasks">
                  <a className="nav-link active" aria-current="page">Atividades</a>
                </LinkContainer>
              </li>              
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default MatintaPageHeader;
